export type Componente = 'T1' | 'IND1' | 'GRU1' | 'P1' | 'T2' | 'IND2' | 'GRU2' | 'P2' | 'EX3' | 'IND3' | 'P3';
export type Notas = Partial<Record<Componente, number | null>>;

export interface Estatistica {
  n: number;
  media: number;
  mediana: number;
  q1: number;
  q3: number;
  desvio: number;
  histograma: number[];
  percentil: number | null;
  valorAluno: number | null;
}

export interface ItemT1 {
  id: string;
  nome: string;
  aluno: number | null;
  mediaTurma: number | null;
  concluiramTurma: number;
}

export interface Requisito {
  id: string;
  nome: string;
  secao: string | null;
  peso: number | null;
  mediaTurma: number | null;
  grupo: { status: string | null; nota: number | null; justificativa: string | null } | null;
}

export interface Criterios {
  prova: string;
  entrega: string;
  como: string[];
  pesos: { grupo: string; itens: string; peso: number; cada?: boolean }[];
  naoDescontado: string[];
  descontos: { situacao: string; efeito: string }[];
  prazo?: string;
}

export interface DisciplinaDesempenho {
  codigo: string;
  nome: string;
  turma: string;
  periodo: string;
  cursoAws: string;
  provaP1: string;
  p3: 'projeto' | 'composta';
  formulas: Record<string, Record<string, number>>;
  awsDisponivel: boolean;
  /** semestre anterior importado só com P1, P2 e P3 */
  somenteNotas: boolean;
  /** mínimo do AWS Academy para o item da T1 contar 10 (abaixo conta 0) */
  corteAws: number | null;
  criterios: Criterios | null;
  correcaoAprovada: boolean;
  notas: Notas;
  pendencias: string[];
  awsIdentificadoPor: string | null;
  grupo: {
    numero: number | null;
    foraDoPrazo: boolean;
    repositorio: string | null;
    integrantes: number;
    commits: number;
    notaCorrecao: number | null;
  } | null;
  turmaInfo: {
    alunos: number;
    grupos: number;
    entregaram: number;
    componentes: Partial<Record<Componente, Estatistica | null>>;
    p1Entregaram: Estatistica | null;
  };
  itensT1: ItemT1[];
  requisitos: Requisito[];
}

export interface Desempenho {
  aluno: { ra: string; nome: string };
  semestre: string | null;
  semestres: string[];
  atualizadoEm: string | null;
  datas: { T1?: string; T2?: string; P1?: Record<string, string> };
  disciplinas: DisciplinaDesempenho[];
}

export interface Eu {
  admin: boolean;
  vinculo: { ra: string; nome: string; emailCps: string | null; desde: string;
    ofertas: boolean;
    celular: string | null;
    celularContato: boolean;
  } | null;
  pendente: { ra: string; email: string; expiraEm: string } | null;
}

export const ROTULOS: Record<Componente, { curto: string; longo: string }> = {
  T1: { curto: 'T1', longo: 'Atividades AWS (T1)' },
  IND1: { curto: 'Individual', longo: 'Nota individual da P1' },
  GRU1: { curto: 'Grupo', longo: 'Nota do grupo na P1' },
  P1: { curto: 'P1', longo: 'P1' },
  T2: { curto: 'T2', longo: 'Atividades AWS (T2)' },
  IND2: { curto: 'Individual', longo: 'Nota individual da P2' },
  GRU2: { curto: 'Grupo', longo: 'Nota do grupo na P2' },
  P2: { curto: 'P2', longo: 'P2' },
  EX3: { curto: 'Exercícios', longo: 'Exercícios (P3)' },
  IND3: { curto: 'Projeto', longo: 'Projeto individual (P3)' },
  P3: { curto: 'P3', longo: 'P3' },
};

/** "20262" → "2026/2" */
export const rotuloSemestre = (s: string | null | undefined) => (s ? `${s.slice(0, 4)}/${s.slice(4)}` : '–');
